<script setup lang="ts">
import { tileActionClass } from "@carnet/ui/utils/tile";

defineProps<{
  icon: string;
}>();
</script>

<template>
  <button type="button" :class="[tileActionClass, 'cursor-pointer']">
    <UIcon :name="icon" class="size-4" aria-hidden="true" />
  </button>
</template>
